module.exports = __webpack_public_path__ + "static/img/cjzh-enterpriseCulture2.9558fbd2.png";